import React from 'react';

/**
 * Rapor/veri sayfalarında sunucu hatasını GÖRÜNÜR kılar.
 *
 * NEDEN: Birçok sayfa `if (res.ok) { setData }` deseniyle 500'ü sessizce yutuyordu
 * → veri null kalıp KPI'lar `|| 0` ile 0 görünüyor, kullanıcı "veri yok" sanıyordu
 * (oysa endpoint ÇÖKÜYOR). Bu banner, hatayı net gösterir + "Tekrar dene" sunar.
 * Backend tarafı da 500'leri loglar + admin'e bildirir (sessiz çökme yok).
 */
export default function ErrorBanner({ error, onRetry }) {
  if (!error) return null;
  return (
    <div
      role="alert"
      style={{
        background: '#fdecea',
        border: '1px solid #f5c6cb',
        color: '#a4342b',
        borderRadius: 8,
        padding: '12px 16px',
        margin: '8px 0',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        fontSize: 14,
      }}
    >
      <span style={{ fontSize: 18 }}>⚠️</span>
      <span style={{ flex: 1 }}>
        Veri yüklenemedi{error && typeof error === 'string' ? ` — ${error}` : ''}. Sunucu hatası olabilir; sorun sürerse yöneticiye bildirin.
      </span>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: '6px 12px',
            border: '1px solid #a4342b',
            background: '#fff',
            color: '#a4342b',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 13,
            whiteSpace: 'nowrap',
          }}
        >
          ↻ Tekrar dene
        </button>
      )}
    </div>
  );
}
